import React from 'react';
import { useHistory } from 'react-router-dom';
import { pathname } from '../../../utils/path/path';
import messages from '../../../messages';
import * as yup from 'yup';
import { updateCompany } from '../../API/company';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { useCompanyContext } from '../../../contexts/Company';

const useStyles = makeStyles((theme) => ({
  fieldContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  field: { maxWidth: 400 },
}));

const nextStep = pathname.onboarding.extras.productUrl;

export default function CompanyName() {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const history = useHistory();
  const { trackEvent } = useEventTrackerContext();
  const { setLoading, setActiveStep } = useOnboardingContext();
  const { business, setBusiness } = useCompanyContext();

  async function handleSubmit(values: { name: string }) {
    try {
      if (business.name !== values.name) {
        setLoading(true);
        await updateCompany({ name: values.name });
        setBusiness({ ...business, name: values.name });
      }
      trackEvent({ event: 'entered_store_name', store_name: values.name });
      setActiveStep(nextStep.stepInStepper);
      history.push(nextStep.url);
    } catch (error) {
      console.log(error.message);
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{ name: business.name || '' }}
      validationSchema={yup.object({ name: yup.string().required() })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <div className={classes.fieldContainer}>
            <Field
              name="name"
              label="Store name"
              component={TextField}
              variant="outlined"
              fullWidth
              className={classes.field}
            />
          </div>
        );
      }}
    />
  );
}
